import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ApiDropPart } from "@/generated/models/ApiDropPart";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiDropGroupMention } from "@/generated/models/ApiDropGroupMention";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import WaveDropPartTitle from "./WaveDropPartTitle";
import WaveDropPartContent from "./WaveDropPartContent";
import { ImageScale } from "@/helpers/image.helpers";
import type { DropContentPresentation } from "./dropContentPresentation";
interface WaveDropPartDropProps {
  drop: ApiDrop;
  activePart: ApiDropPart;
  havePreviousPart: boolean;
  haveNextPart: boolean;
  isStorm: boolean;
  activePartIndex: number;
  setActivePartIndex: (index: number) => void;
  onQuoteClick: (drop: ApiDrop) => void;
  isEditing?: boolean | undefined;
  isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string, mentions?: ApiDropMentionedUser[], mentionedGroups?: ApiDropGroupMention[], mentionedWaves?: ApiMentionedWave[]) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  isCompetitionDrop?: boolean | undefined;
  mediaImageScale?: ImageScale | undefined;
  fullWidthMedia?: boolean | undefined;
  readonly onLinkCardActionsActiveChange?: ((href: string, active: boolean) => void) | undefined;
  readonly contentPresentation?: DropContentPresentation | undefined;
}
const WaveDropPartDrop: React.FC<WaveDropPartDropProps> = t0 => {
  const $ = _c(24);
  const {
    drop,
    activePart,
    havePreviousPart,
    haveNextPart,
    isStorm,
    activePartIndex,
    setActivePartIndex,
    onQuoteClick,
    isEditing: t1,
    isSaving: t2,
    onSave,
    onCancel,
    isCompetitionDrop: t3,
    mediaImageScale: t4,
    fullWidthMedia: t5,
    onLinkCardActionsActiveChange,
    contentPresentation: t6
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  const isSaving = t2 === undefined ? false : t2;
  const isCompetitionDrop = t3 === undefined ? false : t3;
  const mediaImageScale = t4 === undefined ? ImageScale.AUTOx450 : t4;
  const fullWidthMedia = t5 === undefined ? false : t5;
  const contentPresentation = t6 === undefined ? "default" : t6;
  const showStandaloneTitle = contentPresentation !== "quorumCompact";
  let t7;
  if ($[0] !== drop.title || $[1] !== showStandaloneTitle) {
    t7 = showStandaloneTitle && <WaveDropPartTitle title={drop.title} />;
    $[0] = drop.title;
    $[1] = showStandaloneTitle;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  let t8;
  if ($[3] !== activePart || $[4] !== activePartIndex || $[5] !== contentPresentation || $[6] !== drop || $[7] !== fullWidthMedia || $[8] !== haveNextPart || $[9] !== havePreviousPart || $[10] !== isCompetitionDrop || $[11] !== isEditing || $[12] !== isSaving || $[13] !== isStorm || $[14] !== mediaImageScale || $[15] !== onCancel || $[16] !== onLinkCardActionsActiveChange || $[17] !== onQuoteClick || $[18] !== onSave || $[19] !== setActivePartIndex) {
    t8 = <WaveDropPartContent mentionedUsers={drop.mentioned_users} mentionedGroups={drop.mentioned_groups} mentionedWaves={drop.mentioned_waves} referencedNfts={drop.referenced_nfts} wave={drop.wave} activePart={activePart} havePreviousPart={havePreviousPart} haveNextPart={haveNextPart} isStorm={isStorm} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onQuoteClick={onQuoteClick} isEditing={isEditing} isSaving={isSaving} onSave={onSave} onCancel={onCancel} drop={drop} isCompetitionDrop={isCompetitionDrop} mediaImageScale={mediaImageScale} fullWidthMedia={fullWidthMedia} onLinkCardActionsActiveChange={onLinkCardActionsActiveChange} contentPresentation={contentPresentation} />;
    $[3] = activePart;
    $[4] = activePartIndex;
    $[5] = contentPresentation;
    $[6] = drop;
    $[7] = fullWidthMedia;
    $[8] = haveNextPart;
    $[9] = havePreviousPart;
    $[10] = isCompetitionDrop;
    $[11] = isEditing;
    $[12] = isSaving;
    $[13] = isStorm;
    $[14] = mediaImageScale;
    $[15] = onCancel;
    $[16] = onLinkCardActionsActiveChange;
    $[17] = onQuoteClick;
    $[18] = onSave;
    $[19] = setActivePartIndex;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7 || $[22] !== t8) {
    t9 = <div className="tw-relative tw-flex tw-h-full tw-gap-x-3"><div className="tw-flex tw-h-full tw-w-full tw-flex-col tw-self-center sm:tw-self-start"><div>{t7}{t8}</div></div></div>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};
export default WaveDropPartDrop;